import React from 'react'
import Label from '@/app/common/components/Label'
import { Checkbox } from '@/shad/ui/checkbox'

// Props: question, options, value (array), onChange, subLabel
interface CheckboxQuestionProps {
  question: string | React.ReactNode
  options: string[]
  value?: string[]
  onChange: (value: string[]) => void
  subLabel?: string
}

export default function CheckboxQuestion({
  question,
  options,
  value = [],
  onChange,
  subLabel,
}: CheckboxQuestionProps) {
  // Handler for toggling a checkbox
  const handleToggle = (option: string) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option))
    } else {
      onChange([...value, option])
    }
  }

  return (
    <div className="space-y-2">
      <Label>
        {question}
        <span className="text-red-500">*</span>
        <div className="font-normal text-xs">{subLabel}</div>
      </Label>
      <div className="space-y-3 max-h-[14rem] overflow-y-auto border border-gray-100 py-4 px-2 bg-white rounded-md">
        {options.map((option) => {
          const id = question + option

          return (
            <div className="flex items-center space-x-2" key={option}>
              <Checkbox
                id={id}
                checked={value.includes(option)}
                onCheckedChange={() => handleToggle(option)}
              />
              <Label htmlFor={id} weight={'normal'}>
                {option}
              </Label>
            </div>
          )
        })}
      </div>
    </div>
  )
}
